import React, {Component} from 'react';
import {connect} from "react-redux";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';

class HeaderConfiguration extends Component {
    constructor(props){
        super(props);
        this.state = {
            expression: '',
            outputScoreName:''
        };
        this.inputHandle = this.inputHandle.bind(this);
        this.sendData = this.sendData.bind(this);
    }

    componentDidMount(){
        const optionData = this.props.clickedNodeInfo.extras.options;
        const expression = typeof optionData.expression !== 'undefined' && optionData.expression !== null  ? optionData.expression : '',
            outputScoreName = typeof optionData.outputScoreName !== 'undefined' && optionData.outputScoreName !==null ? optionData.outputScoreName:'';

        this.setState({
            expression: expression,
            outputScoreName: outputScoreName
        });
    }

   
    sendData(){
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        clickedNodeInfo.extras.options.expression = this.state.expression;
        clickedNodeInfo.extras.options.outputScoreName = this.state.outputScoreName;
        clickedNodeInfo.extras.name = clickedNodeInfo.name;
        this.props.clickedNodeAction(clickedNodeInfo);
    }

    inputHandle(e){
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    render() {
        return (
            <header className="header-configuration">
                <div className="box">
                    <div className="item">
                        <span className="box-title">Expression</span>
                    </div>
                    <div className="item">
                        <div className="input-wrapper">
                            <input className="panel-input" onChange={this.inputHandle} onBlur={this.sendData}  type="text" name="expression" value={this.state.expression} placeholder="Expression"/>
                        </div>
                    </div>                 
                </div>
                <div className="box">
                    <div className="item">
                        <span className="box-title">Output Score Name</span>
                    </div>
                    <div className="item">
                        <div className="input-wrapper">
                            <input className="panel-input" onChange={this.inputHandle} onBlur={this.sendData}  type="text" name="outputScoreName" value={this.state.outputScoreName} placeholder="Output Score Name"/>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}


function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
    }
}
export default connect(mapStateToProps, {clickedNodeAction})(HeaderConfiguration);
